package com.iregained.site.components.sections.clinics.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val ClinicsHeroStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().styleModifier {
            property("height", "calc(100dvh - 80px)")
            property("background-size", "cover")
            property("background-position", "center")
        }.minHeight(600.px)
    }
}

// Softer, medical-themed gradient instead of harsh black
val ClinicsHeroOverlayStyle = CssStyle {
    base {
        Modifier.fillMaxSize().styleModifier {
                property("background", "linear-gradient(135deg, rgba(0, 128, 128, 0.85) 0%, rgba(0, 64, 64, 0.7) 100%)")
            }.padding(topBottom = 60.px, leftRight = 20.px).display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column).justifyContent(com.varabyte.kobweb.compose.css.JustifyContent.Center)
            .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
    }
}

val ClinicsTwoPaneContainerStyle = CssStyle {
    base {
        Modifier.width(90.percent).maxWidth(1400.px).margin(top = 50.px, bottom = 50.px).backgroundColor(Colors.White)
            .borderRadius(16.px).boxShadow(0.px, 15.px, 50.px, color = rgba(0, 0, 0, 0.1f)) // Softer, wider shadow
            .overflow(Overflow.Hidden).zIndex(10)
    }
}

// Transforms flat list items into floating "Provider Cards"
val ClinicsListItemStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().padding(24.px).margin(bottom = 12.px).backgroundColor(Colors.White)
            .border(1.px, LineStyle.Solid, rgba(0, 0, 0, 0.05f)).borderRadius(12.px).cursor(Cursor.Pointer)
            .boxShadow(0.px, 4.px, 15.px, color = rgba(0, 0, 0, 0.03f)).transition(
                Transition.of("transform", duration = 200.ms),
                Transition.of("box-shadow", duration = 200.ms),
                Transition.of("border-color", duration = 200.ms)
            )
    }
    hover {
        Modifier.translateY((-2).px).boxShadow(0.px, 8.px, 20.px, color = rgba(0, 128, 128, 0.15f))
            .border(1.px, LineStyle.Solid, rgba(0, 128, 128, 0.3f))
    }
}

val ClinicsSearchInputStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette() // <-- Add this
        Modifier.fillMaxWidth().padding(16.px).borderRadius(8.px).border(2.px, LineStyle.Solid, rgba(0, 0, 0, 0.1f))
            .backgroundColor(Colors.White) // <-- FORCES WHITE BACKGROUND
            .color(palette.custom.darkText) // <-- FORCES DARK TEXT
            .fontSize(16.px).outline(0.px).transition(Transition.of("border-color", duration = 200.ms))
    }
    hover { Modifier.border(2.px, LineStyle.Solid, rgba(0, 128, 128, 0.5f)) }
}